import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import logo from "./images/dang_good_logo.png";
import grilledChickenRollImage from "./images/DangGoodCafe_GrilledChickenRicePaperRoll.jpg";
import crispyPorkBowl from "./images/DangGoodCafe_CrispyPorkBellyBowl.jpg";
import grilledChickenBahnMi from "./images/DangGoodCafe_GrilledChickenBahnMi.jpg";
import friedChickenBahnMi from "./images/DangGoodCafe_FriedChickenBahnMi.jpg";
import prawnPorkRicePaperRoll from "./images/DangGoodCafe_Prawn&PorkRicePaperRoll.jpg";
import friedChickenBowl from "./images/DangGoodCafe_FriedChickenBowl.jpg";
import friedTofuBahnMi from "./images/DangGoodCafe_FriedTofuBahnMi.jpg";
import friedTofuBowl from "./images/DangGoodCafe_FriedTofuBowl.jpg";
import hero from "./images/DangGoodCafe_Hero.jpg";
import saltedIcedCoffee from "./images/DangGoodCafe_SaltedIcedCoffee.jpg";
import creamyIcedMatcha from "./images/DangGoodCafe_CreamyIcedMatcha.jpg";
import grilledChickenBowl from "./images/DangGoodCafe_GrilledChickenBowl.jpg";
import strawberryIcedMatcha from "./images/DangGoodCafe_StrawberryIcedMatcha.jpg";
import vietmaneseIcedCoffee from "./images/DangGoodCafe_VietmaneseIcedCoffee.jpg";
import crispyPorkBahnMi from "./images/DangGoodCafe_CrispyPorkBellyBahnMi.jpg";
import crispyPorkRicePaperRoll from "./images/DangGoodCafe_CrispyPorkBellyRicePaperRoll.jpg";
import friedTofuRicePaperRoll from "./images/DangGoodCafe_FriedTofuRicePaperRoll.jpg";
import springRollBowl from "./images/DangGoodCafe_SpringRollBowl.jpg";
import ourStory from "./images/Our_story.jpg";
import background from "./images/Danggood_background.png";
import combo1 from "./images/Combo1.png";
import combo2 from "./images/Combo2.png";
import combo3 from "./images/Combo3.png";

interface CartItem {
  name: string;
  price: number;
  quantity: number;
  image: string;
  isCombo?: boolean;
}

const contactInfo = {
  address: "1/89 High St, Kew VIC 3101",
  phone: "0420 712 860",
  email: "danggood.cafe@gmail.com",
  hours: {
    monday: "Monday: 07:00–15:30",
    tuesday: "Tuesday: 07:00–15:30",
    wednesday: "Wednesday: 07:00–15:30",
    thursday: "Thursday: 07:00–15:30",
    friday: "Friday: 07:00–15:30",
    saturday: "Saturday: Closed",
    sunday: "Sunday: Closed",
  },
};

const App: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("home");
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [cart, setCart] = useState<CartItem[]>([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [checkoutInfo, setCheckoutInfo] = useState({
  name: "",
  email: "",
  company: "",
  address: "",
  phone: "",
  });

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isComboItem = (name: string) =>
    name.includes("Combo 1") || name.includes("Combo 2") || name.includes("Combo 3");

  const addToCart = (name: string, price: string, image: string) => {
    const numericPrice = parseFloat(price.replace("$", ""));
    const comboFlag = isComboItem(name);
    const existingItem = cart.find((item) => item.name === name);
    if (existingItem) {
      setCart(
        cart.map((item) =>
          item.name === name ? { ...item, quantity: item.quantity + 1 } : item
        )
      );
    } else {
      setCart([...cart, { name, price: numericPrice, quantity: 1, image, isCombo: comboFlag }]);
    }
  };

  const cateringCombos = [
  {
    name: "Combo 1 – Snack Attack Pack",
    description: "10 Bánh Mì + 20 Rice Paper Rolls. Add $5 for crispy porks.",
    price: "$190.00",
    image: combo1,
  },
  {
    name: "Combo 2 – Bánh Mì Madness",
    description: "20 Bánh Mì. Add $10 for crispy pork",
    price: "$200.00",
    image: combo2, 
  },
  {
    name: "Combo 3 – Feed the Village",
    description: "20 Bánh Mì + 20 RPR + 20 Spring Rolls. Add $10 for crispy porks.",
    price: "$320.00",
    image: combo3,
  },
  ];

  const removeFromCart = (name: string) => {
    setCart(cart.filter((item) => item.name !== name));
  };

  const updateQuantity = (name: string, newQuantity: number) => {
    if (newQuantity < 1) return;
    setCart(
      cart.map((item) =>
        item.name === name ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const calculateSubtotal = () => {
    return cart.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  const calculateNonComboSubtotal = () => {
    return cart
      .filter((item) => !item.isCombo)
      .reduce((total, item) => total + item.price * item.quantity, 0);
  };

  const calculateDiscount = (nonComboSubtotal: number) => {
    if (nonComboSubtotal >= 500) return 0.1;
    if (nonComboSubtotal >= 200) return 0.05;
    return 0;
  };

  const calculateDiscountAmount = () => {
    const nonComboSubtotal = calculateNonComboSubtotal();
    const discountRate = calculateDiscount(nonComboSubtotal);
    return nonComboSubtotal * discountRate;
  };

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = calculateDiscountAmount();
    return subtotal - discountAmount;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    emailjs
      .send(
        "service_47nkt8p",
        "template_pvfp8bi",
        formData,
        "Oo-5lar_VmiflsgZG" 
      )
      .then(
        () => {
          alert("Message sent successfully!");
          setFormData({ name: "", email: "", subject: "", message: "" });
        },
        () => {
          alert("Failed to send message. Please try again.");
        }
      );
  };

  const menuCategories = [
    {
      id: "rice_paper_roll",
      name: "Rice Paper Roll",
      items: [
        {
          name: "Grilled Chicken Rice Paper Roll",
          description: "Fresh rice paper with grill chicken, herbs, and rice noodles",
          price: "$4.50",
          image: grilledChickenRollImage,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Grilled Chicken Rice Paper Roll",
                  "$4.50",
                  grilledChickenRollImage,
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Crispy Pork Rice Paper Roll",
          description: "Fresh rice paper with crispy pork, herbs, and rice noodles",
          price: "$4.50",
          image: crispyPorkRicePaperRoll,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Crispy Pork Rice Paper Roll",
                  "$4.50",
                  crispyPorkRicePaperRoll,
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Prawn & Pork Rice Paper Roll",
          description: "Fresh rice paper with prawn and pork, herbs, and rice noodles",
          price: "$4.50",
          image: prawnPorkRicePaperRoll,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Prawn & Pork Rice Paper Roll",
                  "$4.50",
                  prawnPorkRicePaperRoll,
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Fried Tofu Rice Paper Roll",
          description: "Fresh rice paper with tofu, herbs, and rice noodles",
          price: "$4.50",
          image: friedTofuRicePaperRoll,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Fried Tofu Rice Paper Roll",
                  "$4.50",
                  friedTofuRicePaperRoll,
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
      ],
    },
    {
      id: "banhmi",
      name: "Banh Mi",
      items: [
        {
          name: "Crispy Pork  Banh Mi",
          description: "Crusty bread rolls with crispy pork, pate, mayo, pickled vegetables, green onion, coriander, fresh chillies and drizzle of seasoning.",
          price: "$12.00",
          image: crispyPorkBahnMi,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Crispy Pork  Banh Mi",
                  "$12.00",
                  crispyPorkBahnMi
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Grilled Chicken  Banh Mi",
          description: "Crusty bread rolls with grilled chicken, pate, mayo, pickled vegetables, green onion, coriander, fresh chillies and drizzle of seasoning.",
          price: "$11.00",
          image: grilledChickenBahnMi,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Grilled Chicken  Banh Mi",
                  "$11.00",
                  grilledChickenBahnMi
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Fried Chicken  Banh Mi",
          description: "Crusty bread rolls with Fried chicken, pate, mayo, pickled vegetables, green onion, coriander, fresh chillies and drizzle of seasoning.",
          price: "$11.00",
          image: friedChickenBahnMi,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Fried Chicken  Banh Mi",
                  "$11.00",
                  friedChickenBahnMi
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Fried Tofu  Banh Mi",
          description: "Crusty bread rolls with Fried Tofu, pate, mayo, pickled vegetables, green onion, coriander, fresh chillies and drizzle of seasoning.",
          price: "$11.00",
          image: friedTofuBahnMi,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Fried Tofu  Banh Mi",
                  "$11.00",
                  friedTofuBahnMi
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
      ],
    },
    {
      id: "dangspecial",
      name: "Dang Special",
      items: [
        {
          name: "Salted Iced Coffee",
          description: "Salted coffee is a mixture of salted foam that provides a creamy top to dark, Robusta coffee.",
          price: "$7.00",
          image: saltedIcedCoffee,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Salted Iced Coffee",
                  "$7.00",
                  saltedIcedCoffee
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Strawberry Iced Matcha",
          description: "The Iced Strawberry Matcha Latte is a fresh strawberry compote with a classic cold matcha.",
          price: "$8.00",
          image: strawberryIcedMatcha,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Strawberry Iced Matcha",
                  "$8.00",
                  strawberryIcedMatcha
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Vietmanese Iced Coffee",
          description: "Vietnamese Iced Coffee is acombination of strong coffee and a hit of sweetened condensed milk with ice",
          price: "$6.00",
          image: vietmaneseIcedCoffee,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Vietmanese Iced Coffee",
                  "$6.00",
                  vietmaneseIcedCoffee
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Creamy Iced Matcha",
          description: "A unique and stimulating blend of matcha green tea powder and milk, lightly sweetened and served over ice.",
          price: "$8.00",
          image: creamyIcedMatcha,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Creamy Iced Matcha",
                  "$8.00",
                  creamyIcedMatcha
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
      ],
    },
    {
      id: "maindish",
      name: "Main Dish",
      items: [
        {
          name: "Crispy Pork  Bowl",
          description: "Slow-roasted pork belly, perfectly crisped to golden perfection, served over a bed of jasmine rice with pickled vegetables, fresh herbs, and a tangy soy-lime glaze.",
          price: "$17.50",
          image: crispyPorkBowl,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Crispy Pork  Bowl",
                  "$17.50",
                  crispyPorkBowl
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Fried Chicken Bowl",
          description: "Crispy, golden-fried chicken served atop steamed jasmine rice, paired with pickled slaw, fresh cucumbers, and drizzled with a house-made spicy mayo.",
          price: "$16.50",
          image: friedChickenBowl,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Fried Chicken Bowl",
                  "$16.50",
                  friedChickenBowl
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Fried Tofu Bowl",
          description: "Crispy golden tofu cubes served over fragrant jasmine rice, topped with pickled vegetables, fresh greens, and a zesty soy-ginger glaze.",
          price: "$16.50",
          image: friedTofuBowl,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Fried Tofu Bowl",
                  "$16.50",
                  friedTofuBowl
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Grilled Chicken Bowl",
          description: "Juicy, marinated grilled chicken served over steamed jasmine rice, accompanied by crisp seasonal vegetables, pickled slaw, and a savory garlic-soy glaze.",
          price: "$16.50",
          image: grilledChickenBowl,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Grilled Chicken Bowl",
                  "$16.50",
                  grilledChickenBowl
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Spring Roll Bowl",
          description: "Rice noodles topped with crisp spring roll, fresh herbs, pickled carrots, finished with crushed peanuts and a drizzle of tangy peanut or nuoc cham sauce.",
          price: "$16.50",
          image: springRollBowl,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Spring Roll Bowl",
                  "$16.50",
                  springRollBowl
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
      ],      
    },
    {
      id: "catering_combos",
      name: "Catering Combos",
      items: [
        {
          name: "Combo 1 – Snack Attack Pack",
          description:
            "10 Bánh Mì + 20 Rice Paper Rolls. Add $5 for crispy porks.",
          price: "$190.00",
          image: combo1, 
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Combo 1 – Snack Attack Pack",
                  "$190.00",
                  combo1
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Combo 2 – Bánh Mì Madness",
          description:
            "20 Bánh Mì. Add $10 for crispy pork",
          price: "$200.00",
          image: combo2,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Combo 2 – Bánh Mì Madness",
                  "$200.00",
                  combo2
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
        {
          name: "Combo 3 – Feed the Village",
          description:
            "20 Bánh Mì + 20 RPR + 20 Spring Rolls. Add $10 for crispy porks.",
          price: "$320.00",
          image: combo3,
          button: (
            <button
              onClick={() =>
                addToCart(
                  "Combo 3 – Feed the Village",
                  "$320.00",
                  combo3
                )
              }
              className="mt-4 bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
            >
              Add to Cart
            </button>
          ),
        },
      ],
    },
  ];

  const cateringContent = {
    packages: {
      title: "Our Packages",
      content:
        "Choose from our thoughtfully crafted catering packages or collaborate with us to design a custom menu. We offer a variety of options, including buffet-style trays, appetizer platters, and build-your-own meal kits — all freshly prepared and ready for pickup or delivery. Every order includes premium packaging and easy-to-follow serving instructions to ensure a seamless experience.",
      image: hero,
    },
  };

  const renderContent = () => {
    switch (activeTab) {
      case "menu":
        return (
          <div className="pt-16 pb-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Menu</h2>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Experience our unique blend of modern Vietnamese coffee culture and delicious cuisine.
                </p>
              </div>
              {menuCategories.map((category) => (
                <div key={category.id} className="mb-16">
                  <h3 className="text-2xl font-bold text-gray-900 mb-8 pb-2 border-b border-gray-200">
                    {category.name}
                  </h3>
                  <div className="grid md:grid-cols-3 gap-8">
                    {category.items.map((item, index) => (
                      <div
                        key={index}
                        className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform duration-300 hover:transform hover:scale-105"
                      >
                        <div className="h-48 overflow-hidden">
                          <img
                            src={item.image}
                            alt={item.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="p-6">
                          <div className="flex justify-between items-start mb-2">
                            <h4 className="text-xl font-bold text-gray-900">{item.name}</h4>
                            <span className="text-yellow-400 font-bold">{item.price}</span>
                          </div>
                          <p className="text-gray-600 text-sm">{item.description}</p>
                          {item.button}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      case "about":
        return (
          <div className="pt-16 pb-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">Catering Services</h2>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Elevate your events with authentic Vietnamese cuisine and professional service.
                </p>
              </div>
              <div className="bg-red-50 rounded-lg p-8 mb-16 text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Plan Your Event?</h3>
                <p className="text-gray-600 mb-6">
                  Contact us today to discuss your catering needs and receive a customized quote.
                </p>
                <button className="bg-black text-yellow-400 px-8 py-3 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer" onClick={() => setActiveTab("contact")}>
                  Get Quote
                </button>
              </div>
              {Object.values(cateringContent).map((section, index) => (
                <div
                  key={index}
                  className={`grid md:grid-cols-2 gap-12 items-center mb-16 ${index % 2 === 1 ? "md:flex-row-reverse" : ""}`}
                >
                  <div className={index % 2 === 1 ? "order-2 md:order-1" : ""}>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{section.title}</h3>
                    <p className="text-gray-600 mb-6">{section.content}</p>
                  </div>
                  <div className={index % 2 === 1 ? "order-1 md:order-2" : ""}>
                    <img
                      src={section.image}
                      alt={section.title}
                      className="rounded-lg shadow-lg w-full h-auto"
                    />
                  </div>
                </div>
              ))}
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Catering Combos</h3>
                <div className="grid md:grid-cols-3 gap-8">
                  {cateringCombos.map((combo, idx) => (
                    <div key={idx} className="bg-white rounded-lg overflow-hidden shadow-lg flex flex-col">
                      <img src={combo.image} alt={combo.name} className="w-full h-48 object-cover" />
                      <div className="p-6 flex-1 flex flex-col">
                        <h4 className="text-xl font-bold text-gray-900 mb-2">{combo.name}</h4>
                        <p className="text-gray-600 mb-4">{combo.description}</p>
                        <span className="text-yellow-400 font-bold mb-4">{combo.price}</span>
                        <button
                          className="mt-auto bg-black text-yellow-400 px-4 py-2 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
                          onClick={() => addToCart(combo.name, combo.price, combo.image)}
                        >
                          Add to Cart
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      case "contact":
        return (
          <div className="pt-16 pb-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h2>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  We'd love to hear from you. Reach out for reservations, feedback, or inquiries.
                </p>
              </div>
              <div className="grid md:grid-cols-2 gap-12">
                <div>
                  <div className="bg-white rounded-lg shadow-lg p-8">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">Send Us a Message</h3>
                    <form className="space-y-6" onSubmit={handleSubmit}>
                      <div>
                        <label
                          htmlFor="name"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          id="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-yellow-400 focus:border-yellow-400"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          id="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-yellow-400 focus:border-yellow-400"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="subject"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Subject
                        </label>
                        <input
                          type="text"
                          id="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-yellow-400 focus:border-yellow-400"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="message"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Message
                        </label>
                        <textarea
                          id="message"
                          rows={4}
                          value={formData.message}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-yellow-400 focus:border-yellow-400"
                        ></textarea>
                      </div>
                      <button
                        type="submit"
                        className="bg-black text-yellow-400 px-6 py-3 rounded-button hover:bg-gray-800 whitespace-nowrap cursor-pointer"
                      >
                        Send Message
                      </button>
                    </form>
                  </div>
                </div>
                <div>
                  <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
                    <div className="space-y-4">
                      <div className="flex items-start">
                        <i className="fas fa-map-marker-alt text-yellow-400 mt-1 mr-3"></i>
                        <p className="text-gray-600">{contactInfo.address}</p>
                      </div>
                      <div className="flex items-start">
                        <i className="fas fa-phone-alt text-yellow-400 mt-1 mr-3"></i>
                        <p className="text-gray-600">{contactInfo.phone}</p>
                      </div>
                      <div className="flex items-start">
                        <i className="fas fa-envelope text-yellow-400 mt-1 mr-3"></i>
                        <p className="text-gray-600">{contactInfo.email}</p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg shadow-lg p-8">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">Opening Hours</h3>
                    <div className="space-y-2">
                      <div className="flex items-start">
                        <i className="fas fa-clock text-yellow-400 mt-1 mr-3"></i>
                        <div>
                          <p className="text-gray-600">{contactInfo.hours.monday}</p>
                          <p className="text-gray-600">{contactInfo.hours.tuesday}</p>
                          <p className="text-gray-600">{contactInfo.hours.wednesday}</p>
                          <p className="text-gray-600">{contactInfo.hours.thursday}</p>
                          <p className="text-gray-600">{contactInfo.hours.friday}</p>
                          <p className="text-gray-600">{contactInfo.hours.saturday}</p>
                          <p className="text-gray-600">{contactInfo.hours.sunday}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <>
            <div className="relative pt-16">
              <div className="absolute inset-0">
                <img
                  src={background}
                  alt="Hero Background"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black opacity-50"></div>
              </div>
              <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
                <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
                  Dang Good Coffee & Food
                </h1>
                <p className="text-xl text-white mb-8 max-w-2xl">
                  Where modern Vietnamese coffee culture meets delicious cuisine. Experience the perfect blend of tradition and innovation.
                </p>
                <div className="flex flex-wrap gap-4">
                  <button
                    onClick={() => setActiveTab("menu")}
                    className="bg-yellow-400 text-black px-8 py-3 rounded-button hover:bg-yellow-500 whitespace-nowrap cursor-pointer"
                  >
                    View Menu
                  </button>
                </div>
              </div>
            </div>
            <div className="py-16 bg-white">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Signature Dishes</h2>
                  <p className="text-gray-600 max-w-2xl mx-auto">
                    Discover our most popular dishes, crafted with authentic Vietnamese recipes and the finest ingredients.
                  </p>
                </div>
                <div className="grid md:grid-cols-3 gap-8">
                  {[
                    {
                      title: "Rice Paper Roll",
                      description: "Fresh Vietnamese Rolls with Herbs, Veggies & Your Choice of Protein",
                      image: grilledChickenRollImage
                    },
                    {
                      title: "Bánh Mì",
                      description: "Crispy Baguette Filled with Savory Protein, Pickled Veggies & Fresh Herbs",
                      image: friedChickenBahnMi
                    },
                    {
                      title: "Matcha Latte",
                      description: "Creamy Matcha Delight with a Hint of Sweetness",
                      image: creamyIcedMatcha
                    },
                  ].map((dish, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform duration-300 hover:transform hover:scale-105 cursor-pointer"
                    >
                      <img
                        src={dish.image}
                        alt={dish.title}
                        className="w-full h-48 object-cover"
                      />
                      <div className="p-6">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">{dish.title}</h3>
                        <p className="text-gray-600">{dish.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="bg-gray-50 py-16">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-2 gap-12 items-center">
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
                    <p className="text-gray-600 mb-6">
                      Founded with a passion for exceptional coffee and Vietnamese cuisine, Dang Good Cafe brings a modern twist to traditional flavors. We pride ourselves on serving premium Vietnamese coffee and delicious food in a contemporary setting.
                    </p>
                    <button
                      onClick={() => setActiveTab("about")}
                      className="bg-yellow-400 text-black px-6 py-3 rounded-button hover:bg-yellow-500 whitespace-nowrap cursor-pointer"
                    >
                      Learn More
                    </button>
                  </div>
                  <div>
                    <img
                      src= {ourStory}
                      alt="Our Kitchen"
                      className="rounded-lg shadow-lg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <nav className="bg-white shadow-lg fixed w-full z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <img
                src={logo}
                alt="Dang Good Cafe Logo"
                className="h-16 cursor-pointer"
                onClick={() => setActiveTab("home")}
              />
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#home"
                className={`${activeTab === "home" ? "text-yellow-400" : "text-gray-800"} hover:text-yellow-400 cursor-pointer`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("home");
                }}
              >
                Home
              </a>
              <a
                href="#menu"
                className={`${activeTab === "menu" ? "text-yellow-400" : "text-gray-800"} hover:text-yellow-400 cursor-pointer`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("menu");
                }}
              >
                Menu
              </a>
              <a
                href="#about"
                className={`${activeTab === "about" ? "text-yellow-400" : "text-gray-800"} hover:text-yellow-400 cursor-pointer`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("about");
                }}
              >
                Catering
              </a>
              <a
                href="#contact"
                className={`${activeTab === "contact" ? "text-yellow-400" : "text-gray-800"} hover:text-yellow-400 cursor-pointer`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("contact");
                }}
              >
                Contact
              </a>
              <div className="flex items-center space-x-4">
                <button
                  className="relative bg-yellow-400 text-black px-6 py-2 rounded-button hover:bg-yellow-500 whitespace-nowrap cursor-pointer"
                  onClick={() => setIsCartOpen(!isCartOpen)}
                >
                  <i className="fas fa-shopping-cart mr-2"></i>
                  Cart
                  {cart.length > 0 && (
                    <span className="absolute -top-2 -right-2 bg-black text-yellow-400 rounded-full w-5 h-5 flex items-center justify-center text-xs">
                      {cart.reduce((total, item) => total + item.quantity, 0)}
                    </span>
                  )}
                </button>
              </div>
              {isCartOpen && (
                <div className="fixed right-0 top-0 h-full w-96 bg-white shadow-lg z-50 overflow-y-auto">
                  <div className="p-6">
                    <div className="flex justify-between items-center mb-6">
                      <h3 className="text-xl font-bold">Shopping Cart</h3>
                      <button
                        onClick={() => setIsCartOpen(false)}
                        className="text-gray-500 hover:text-gray-700"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                    {cart.length === 0 ? (
                      <p className="text-gray-500 text-center py-8">Your cart is empty</p>
                    ) : (
                      <>
                        <div className="space-y-4 mb-6">
                          {cart.map((item) => (
                            <div
                              key={item.name}
                              className="flex items-center space-x-4 border-b pb-4"
                            >
                              <img
                                src={item.image}
                                alt={item.name}
                                className="w-20 h-20 object-cover rounded"
                              />
                              <div className="flex-1">
                                <h4 className="font-medium">{item.name}</h4>
                                <p className="text-gray-600">${item.price.toFixed(2)}</p>
                                <div className="flex items-center space-x-2 mt-2">
                                  <button
                                    onClick={() => updateQuantity(item.name, item.quantity - 1)}
                                    className="text-gray-500 hover:text-gray-700"
                                  >
                                    <i className="fas fa-minus"></i>
                                  </button>
                                  <span>{item.quantity}</span>
                                  <button
                                    onClick={() => updateQuantity(item.name, item.quantity + 1)}
                                    className="text-gray-500 hover:text-gray-700"
                                  >
                                    <i className="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                              <button
                                onClick={() => removeFromCart(item.name)}
                                className="text-red-500 hover:text-red-700"
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </div>
                          ))}
                        </div>
                        <div className="space-y-4 border-t pt-4">
                          <div className="flex justify-between">
                            <span>Subtotal:</span>
                            <span>${calculateSubtotal().toFixed(2)}</span>
                          </div>
                          {/* Show discount only if there is a discount */}
                          {calculateDiscountAmount() > 0 && (
                            <div className="flex justify-between text-yellow-400">
                              <span>Discount (applied only to non-combo items):</span>
                              <span>
                                -${calculateDiscountAmount().toFixed(2)}
                              </span>
                            </div>
                          )}
                          <div className="flex justify-between font-bold">
                            <span>Total:</span>
                            <span>${calculateTotal().toFixed(2)}</span>
                          </div>
                          <div className="text-sm text-gray-500">
                            <p>Spend $200 for 5% discount on non-combo items</p>
                            <p>Orders over $500 please contact us directly for special pricing</p>
                          </div>
                          <button
                            className="w-full bg-yellow-400 text-black py-3 rounded-button hover:bg-yellow-500 whitespace-nowrap cursor-pointer"
                            onClick={() => setIsCheckoutOpen(true)}
                          >
                            Proceed to Checkout
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
              {isCheckoutOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-60">
                  <div className="bg-white rounded-lg p-8 shadow-lg max-w-md w-full">
                    <h3 className="text-2xl font-bold mb-4 text-gray-900">Order Details</h3>
                    <form
                      onSubmit={async (e) => {
                        e.preventDefault();
                        const orderDetails = cart.map(
                          (item) => `${item.name} x${item.quantity} ($${item.price.toFixed(2)})`
                        ).join('\n');
                        const emailParams = {
                          name: checkoutInfo.name,
                          email: checkoutInfo.email,
                          phone: checkoutInfo.phone,
                          company: checkoutInfo.company,
                          address: checkoutInfo.address,
                          message: `Order Details:\n${orderDetails}\n\nTotal: $${calculateTotal().toFixed(2)}`,
                        };
                        try {
                          await emailjs.send(
                            "service_47nkt8p",
                            "template_cr0911c",
                            emailParams,
                            "Oo-5lar_VmiflsgZG"
                          );
                          alert("Order sent successfully! We will contact you soon to confirm.");
                          setIsCheckoutOpen(false);
                          setCart([]);
                          setCheckoutInfo({ name: "", email: "", phone: "", company: "", address: "" });
                        } catch {
                          alert("Failed to send order. Please try again.");
                        }
                      }}
                      className="space-y-4"
                    >
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Your Name</label>
                        <input
                          type="text"
                          required
                          value={checkoutInfo.name}
                          onChange={e => setCheckoutInfo({ ...checkoutInfo, name: e.target.value })}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                        <input
                          type="email"
                          required
                          value={checkoutInfo.email}
                          onChange={e => setCheckoutInfo({ ...checkoutInfo, email: e.target.value })}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Contact Number</label>
                        <input
                          type="tel"
                          required
                          value={checkoutInfo.phone}
                          onChange={e => setCheckoutInfo({ ...checkoutInfo, phone: e.target.value })}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Company Name</label>
                        <input
                          type="text"
                          required
                          value={checkoutInfo.company}
                          onChange={e => setCheckoutInfo({ ...checkoutInfo, company: e.target.value })}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Company Address</label>
                        <input
                          type="text"
                          required
                          value={checkoutInfo.address}
                          onChange={e => setCheckoutInfo({ ...checkoutInfo, address: e.target.value })}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md"
                        />
                      </div>
                      <button
                        type="submit"
                        className="w-full bg-black text-yellow-400 py-2 rounded-button hover:bg-gray-800"
                      >
                        Submit Order
                      </button>
                      <button
                        type="button"
                        className="w-full mt-2 bg-gray-200 text-gray-700 py-2 rounded-button hover:bg-gray-300"
                        onClick={() => setIsCheckoutOpen(false)}
                      >
                        Cancel
                      </button>
                    </form>
                  </div>
                </div>
              )}
            </div>
            <div className="md:hidden flex items-center">
              <button onClick={toggleMenu} className="text-gray-800 cursor-pointer">
                <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"} text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>
        <div className={`md:hidden ${isMenuOpen ? "block" : "hidden"}`}>
          <div className="px-2 pt-2 pb-3 space-y-1 bg-white">
            <a
              href="#home"
              className={`block px-3 py-2 ${activeTab === "home" ? "text-yellow-400" : "text-gray-800"} hover:text-yellow-400 cursor-pointer`}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab("home");
                setIsMenuOpen(false);
              }}
            >
              Home
            </a>
            <a
              href="#menu"
              className={`block px-3 py-2 ${activeTab === "menu" ? "text-yellow-400" : "text-gray-800"} hover:text-yellow-400 cursor-pointer`}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab("menu");
                setIsMenuOpen(false);
              }}
            >
              Menu
            </a>
            <a
              href="#about"
              className={`block px-3 py-2 ${activeTab === "about" ? "text-yellow-400" : "text-gray-800"} hover:text-yellow-400 cursor-pointer`}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab("about");
                setIsMenuOpen(false);
              }}
            >
              Catering
            </a>
            <a
              href="#contact"
              className={`block px-3 py-2 ${activeTab === "contact" ? "text-yellow-400" : "text-gray-800"} hover:text-yellow-400 cursor-pointer`}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab("contact");
                setIsMenuOpen(false);
              }}
            >
              Contact
            </a>
            <button className="w-full text-left px-3 py-2 text-yellow-400 font-medium cursor-pointer">
              Order Now
            </button>
          </div>
        </div>
      </nav>
      {renderContent()}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">Dang Good Cafe</h3>
              <p className="text-gray-400">Modern Vietnamese Coffee & Cuisine</p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Hours</h3>
              <p className="text-gray-400">{contactInfo.hours.monday}</p>
              <p className="text-gray-400">{contactInfo.hours.tuesday}</p>
              <p className="text-gray-400">{contactInfo.hours.wednesday}</p>
              <p className="text-gray-400">{contactInfo.hours.thursday}</p>
              <p className="text-gray-400">{contactInfo.hours.friday}</p>
              <p className="text-gray-400">{contactInfo.hours.saturday}</p>
              <p className="text-gray-400">{contactInfo.hours.sunday}</p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Contact</h3>
              <p className="text-gray-400">{contactInfo.address}</p>
              <p className="text-gray-400">Tel: {contactInfo.phone}</p>
              <p className="text-gray-400">{contactInfo.email}</p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Follow Us</h3>
              <div className="space-y-3">
                <div className="bg-blue-600 rounded-lg p-3 flex items-center space-x-3 hover:shadow-lg transition-shadow cursor-pointer">
                  <div className="w-8 h-8 bg-white rounded flex items-center justify-center">
                    <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </div>
                  <a
                    href="https://www.facebook.com/profile.php?id=61574880101370"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white font-medium hover:underline"
                  >
                    Dang Good Cafe
                  </a>
                </div>
                <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg p-3 flex items-center space-x-3 hover:shadow-lg transition-shadow cursor-pointer">
                  <div className="w-8 h-8 bg-white rounded flex items-center justify-center">
                    <svg className="w-5 h-5 text-pink-600" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.982-6.98.058-1.281.072-1.689.072-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.981-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </div>
                  <a
                    href="https://www.instagram.com/danggood.cafe/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white font-medium hover:underline"
                  >
                    Dang Good Cafe
                  </a>
                </div>
                <div className="bg-black rounded-lg p-3 flex items-center space-x-3 hover:shadow-lg transition-shadow cursor-pointer">
                  <div className="w-8 h-8 bg-white rounded flex items-center justify-center">
                    <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                    </svg>
                  </div>
                  <a
                    href="https://www.tiktok.com/@dang.good8"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white font-medium hover:underline"
                  >
                    Dang Good Cafe
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>© 2025 Dang Good Cafe. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;